import { FacilitiesCreate } from './FacilitiesCreate'
import { FacilitiesList } from './FacilitiesList'
import { FacilitiesEdit } from './FacilitiesEdit'

export { FacilitiesCreate, FacilitiesList, FacilitiesEdit }


// WEBPACK FOOTER //
// ./src/components/facilities/index.js